import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.scss']
})
export class NewsDetailComponent implements OnInit {
  newsContent: SafeHtml = '';
  newsId = '';
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
  ) {}

  ngOnInit(): void {
    this.newsId = this.route.snapshot.params['id'] || '';
    if (this.newsId) {
      const url = `${environment.newsStaticUrl}/${this.newsId}.html`;
      this.http.get(url, { responseType: 'text' }).subscribe({
        next: (html) => {
          // 将图片相对路径替换为绝对路径，避免 [innerHTML] 渲染时基于当前页面 URL 解析
          const fixedHtml = html.replace(
            /(<img\s[^>]*?\bsrc=")images\//g,
            `$1${environment.newsStaticUrl}/images/`
          );
          this.newsContent = this.sanitizer.bypassSecurityTrustHtml(fixedHtml);
          this.loading = false;
        },
        error: () => {
          this.newsContent = '<p style="color:#999;text-align:center;padding:3rem;">内容加载失败</p>';
          this.loading = false;
        }
      });
    } else {
      this.loading = false;
    }
    window.scrollTo(0, 0);
  }

  goBack(): void {
    const country = this.route.snapshot.params['country'];
    const basePath = country
      ? `/${country}/gb/cn/news`
      : '/gb/cn/news';
    this.router.navigate([basePath]);
  }
}
